import React, { useEffect, useState } from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import { handleError, toastError } from '../funciones';
import axios from '../axiosConfig';
import { TablaN } from './TablaN';


export const TablaAxios = ({ url, params, contenidoFilaTabla, id, itemsEncabezado, elemNoEncontrado, ocultarEncabezadoMobile, classNameTabla,
    onDataLoaded }) => {
    const [elementos, setElementos] = useState([]);
    const [mostrarLoader, setMostrarLoader] = useState(true);
    useEffect(() => {
        axios
            .get(process.env.REACT_APP_URL + url, params)
            .then(function (response) {
                setMostrarLoader(false)
                setElementos(response.data);
                if (onDataLoaded) {
                    onDataLoaded(response.data);
                }
            })
            .catch(function (error) {
                setMostrarLoader(false)
                toastError(handleError(error))
            });
    }, [])

    function contenidoFila(elem) {
        if (!contenidoFilaTabla)
            return elem
        else
            return contenidoFilaTabla(elem)
    }


    return (
        <>
            <>
                <TablaN itemsEncabezado={itemsEncabezado} id={id} elemNoEncontrado={elemNoEncontrado} classNameTabla={classNameTabla}
                    elementos={elementos} itemsFilas={contenidoFila} ocultarEncabezadoMobile={ocultarEncabezadoMobile} mostrarLoader={mostrarLoader} />
            </>
        </>
    );
}
